var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpotifyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#10BC4C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0072 6.02588H6.00005V18.0438H18.0072V6.02588Z",
    fill: "#10BC4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0036 6.02588C8.70167 6.02588 6.00005 8.7299 6.00005 12.0348C6.00005 15.3397 8.70167 18.0438 12.0036 18.0438C15.3056 18.0438 18.0072 15.3397 18.0072 12.0348C18.0072 8.7299 15.3356 6.02588 12.0036 6.02588ZM14.7653 14.7088C14.6452 14.8891 14.4351 14.9491 14.255 14.829C12.8441 13.9577 11.0731 13.7774 8.97183 14.2581C8.7617 14.3182 8.58159 14.168 8.52156 13.9877C8.46152 13.7774 8.61161 13.5971 8.79172 13.537C11.0731 13.0263 13.0543 13.2366 14.6152 14.198C14.8253 14.2882 14.8554 14.5285 14.7653 14.7088ZM15.4857 13.0563C15.3356 13.2666 15.0655 13.3568 14.8554 13.2066C13.2344 12.2151 10.7729 11.9146 8.88177 12.5155C8.64163 12.5756 8.37147 12.4554 8.31143 12.2151C8.2514 11.9747 8.37147 11.7043 8.61161 11.6442C10.8029 10.9833 13.5045 11.3137 15.3657 12.4554C15.5458 12.5456 15.6358 12.846 15.4857 13.0563ZM15.5458 11.3738C13.6246 10.2321 10.4127 10.112 8.58159 10.6828C8.28141 10.7729 7.98123 10.5927 7.89118 10.3223C7.80113 10.0218 7.98123 9.72137 8.2514 9.63124C10.3827 9.0003 13.8948 9.12048 16.1161 10.4424C16.3863 10.5927 16.4763 10.9532 16.3262 11.2236C16.1761 11.4339 15.8159 11.5241 15.5458 11.3738Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotifyIcon);
export default __webpack_public_path__ + "static/media/spotify-icon.da0680c89af2b787a56428fd7065a1f9.svg";
export { ForwardRef as ReactComponent };